<template lang="pug">
  .freebet
    .freebet__img
      img(:src="freespin.image_url" alt="img")

    .freebet__holder
      .freebet__type Freebet 7EUR
      .freebet__title {{ freespin.title }}

      .freebet__description(v-html="getLocalizedParam(freespin, 'description')")

      .freebet__price
        Currency(size="24" type="coins") {{ freespin.price  }}
        .freebet__coins {{ $t('countCoins') }}
      Button.freebet__button(is-primary, is-small, @click="buy") {{ $t("buy") }}

</template>

<script>
export default {
  props: {
    freespin: {
      type: Object,
      required: true
    }
  },
  methods: {
    buy () {
      this.$emit('buy')
    },

    getLocalizedParam (product, param) {
      let locale = this.$i18n.locale

      if (!product.extra_data?.text?.[locale]) {
        locale = 'en'
      }

      return product.extra_data?.text?.[locale]?.[param]
    }
  }
}
</script>

<style lang="scss" scoped>
.freebet {
  padding: 34px 20px;
  color: $white;
  font-size: 12px;
  background-color: $blue-grey70;
  overflow: hidden;

  @media (min-width: $breakpointTablet) {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    padding: 16px;
  }

  @media (min-width: $breakpointDesktop) {
    position: relative;
  }

  &__img {
    margin-bottom: 12px;
    text-align: center;

    @media (min-width: $breakpointTablet) {
      margin-bottom: 0;
    }

    @media (min-width: $breakpointDesktop) {
      position: absolute;
      width: 50%;
      right: -55px;
      bottom: 10px;
    }
  }

  &__holder {
    z-index: 1;
  }

  &__type {
    margin-bottom: 8px;
    color: #90A4AE;
    text-transform: uppercase;
  }

  &__title {
    margin-bottom: 8px;
    font-size: 20px;
    font-weight: 500;
  }

  &__price {
    margin-top: 16px;
    font-size: 16px;
    font-weight: 700;
  }

  &__button {
    width: 100%;
    margin-top: 16px;

    @media (min-width: $breakpointTablet) {
      width: 168px;
    }
  }

  &__coins {
    color: #90A4AE;
    margin-left: 26px;
  }
}
</style>
